import React, { createContext, useContext, useState, useEffect } from 'react'

import { roomKeys } from 'helpers/events'

export const selectedParticipantContext = createContext(null)

export default function useSelectedParticipant() {
    const [selectedParticipant, setSelectedParticipant] = useContext(
        selectedParticipantContext
    )
    return [selectedParticipant, setSelectedParticipant]
}

export function SelectedParticipantProvider({ room, children }) {
    const [selectedParticipant, _setSelectedParticipant] = useState(null)
    const setSelectedParticipant = participant =>
        _setSelectedParticipant(prevParticipant =>
            prevParticipant === participant ? null : participant
        )

    useEffect(() => {
        const onDisconnect = () => _setSelectedParticipant(null)

        room.addListener(roomKeys.DISCONNECTED, onDisconnect)

        return () => {
            room.removeListener(roomKeys.DISCONNECTED, onDisconnect)
        }
    }, [room])

    return (
        <selectedParticipantContext.Provider
            value={[selectedParticipant, setSelectedParticipant]}
        >
            {children}
        </selectedParticipantContext.Provider>
    )
}
